import type { ComposerTranslation } from 'vue-i18n';
import type { CardItem } from '@/domains/home/apis/home-api';
import { ProductType } from '../types/base';
import { getPlaybookIcon, getPlaybookPath, ifPlaybookInternal } from './playbook';

export { getPlaybookIcon, getPlaybookPath };

export function isPlaybook(type: string) {
  return type === 'P';
}

export function cardName(recommendItem: CardItem, t: ComposerTranslation) {
  if (isPlaybook(recommendItem.type)) {
    return t(`playbook.${recommendItem.function_id}.title`);
  } else {
    return recommendItem.name;
  }
}

export function cardDesc(recommendItem: CardItem, t: ComposerTranslation) {
  if (isPlaybook(recommendItem.type)) {
    return t(`playbook.${recommendItem.function_id}.desc`);
  } else {
    const desc = recommendItem.description || recommendItem.goal || '';
    return desc.trim().split('\n')[0];
  }
}

export function gotoPlaybook(playbook: string, router: any) {
  const path = getPlaybookPath(playbook);
  const internal = ifPlaybookInternal(playbook);
  if (internal && path) {
    router.push({ path });
  } else if (path) {
    location.href = path;
  }
}

export function productTypeStyle(type: ProductType) {
  switch (type) {
    case ProductType.IP:
      return 'bg-green-40 text-green-600';
    case ProductType.RD:
      return 'bg-blue-75 text-eureka-500';
    case ProductType.LS:
      return 'bg-[#EDF1FF] text-[#5B5EF9]';
    case ProductType.MS:
      return 'bg-spring-40 text-spring-500';
    case ProductType.SCOUT:
      return 'bg-blue-75 text-eureka-700';
    case ProductType.PROTECT:
      return 'bg-green-40 text-green-500';
  }
}
